.radio-tab-selector-button-bar__container {
  display: flex;
  flex-wrap: wrap;
}

.radio-tab-selector-button-bar__container--label-left {
  align-items: baseline;
  flex-direction: row;
  gap: 1rem;
}

.radio-tab-selector-button-bar__container--label-top {
  align-items: flex-start;
  flex-direction: column;
  gap: 0.5rem;
}

.radio-tab-selector-button-bar__row-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.radio-tab-selector-button-bar__row {
  align-items: center;
  background-color: var(--color-uva-white);
  border: 1px solid var(--color-grey-700);
  border-radius: 0.5rem;
  display: flex;
  flex-wrap: nowrap;
  gap: 0.25rem;
  padding: 0.25rem;
}

.radio-tab-selector-button-bar__row--not-validated {
  border-color: var(--color-red-600);
}
